<template>
    <div class="signdetail">
        <div class="body">
            <mVideo
                :videoUrl="detail.mediaurl"
                v-if="detail.mediaurl"
                height="4rem"
                fit="contain"
            ></mVideo>
            <VanImage :src="detail.icon" style="width: 7.5rem;height:3.15rem;" v-else></VanImage>

            <div class="title">{{detail.title}}</div>
            <div class="hr" v-if="detail.mcount*1 >0 || joinList.length >0"></div>
            <div class="my" v-if="$route.params.type ==1 && detail.mcount*1 >0" @click="goRank">
                <div>已完成：{{detail.mcount}}</div>
                <div class="btn">查看排行榜</div>
            </div>
            <div v-if="$route.params.type ==2 && joinList.length >0" class="my">
                <div v-if="joinList.length" class="joinuser">
                    <van-image
                    :src="item.avatarurl"
                    v-for="(item, index) in joinList.slice(0, 5)"
                    :key="index"
                    :style="
                        `transform:translateX(${(joinList.slice(0, 5).length -
                        1 -
                        index) *
                        25}%)`
                    "
                    :data-index="index"
                    />
                </div>
                <div>
                    <div>{{detail.count}} 人已完成</div>
                    <div class="btn" @click="goRank">查看排行榜</div>
                </div>
            </div>
            <div class="hr" v-if="detail.mcount*1 >0 || joinList.length >0"></div>
            <div class="cont">
                <div class="tip">规则介绍</div>
                <div class="vhtml" v-html="detail.rules"></div>
            </div>
        </div>
        <Footbar>
            <Cell slot="footbar">
                <Button
                    v-if="detail.today_state !== 1"
                    round
                    type="primary"
                    block
                    :disabled="detail.disabled"
                    color="#FB6400"
                    @click="godetail"
                    >立即参与</Button>
                <Button
                    v-else
                    round
                    type="primary"
                    block
                    color="#FB6400"
                    :to="{ name: 'sportsResult', params: this.$route.params }"
                    >参赛详情</Button>
            </Cell>
                
        </Footbar>
    </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup,ActionSheet } from "vant";

export default {
    data() {
        return {
            detail: {},
            joinList: []
        }
    },
    components: {
        mVideo,
        Empty,
        Panel,
        Cell,
        Button,
        CellGroup,
        Footbar,
        VanImage: Image,
        Popup,
        vanActionSheet: ActionSheet
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        init() {
            let query = {
                cpgid: this.$route.params.id
            }
            this.$api.sports.getComparegame(query).then(res=>{
                this.detail = res.data
                this.joinList = res.data.list
                this.$toast.clear();
            })
        },
        godetail() {
            this.$router.push({name: 'joinSports', params: {item_sub_id: this.detail.id,sports_id:this.detail.sports_id,signtype:this.detail.signtype} })
        },
        goRank() {
            this.$router.push({ name: "newsportsRank", params: {item_sub_id: this.detail.id,sports_id:this.detail.sports_id,item_id:this.detail.sports_item_id,}, query: {rank_type: this.detail.rank_type} });
        },
    }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>